export const SIGN_UP_ONBOARDING_STAGES = {
  ACTIVATED: 'activated',
  PROFILE_CREATED: 'profile_created',
  PROFILE_COMPLETED: 'profile_completed',
  CLASSES_IMPORTED: 'classes_imported'
};
